export const GOOGLE_MAPS_CONFIG = {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: ['places'],
  region: 'FR',
  language: 'fr',
  options: {
    types: [],
    fields: [
      'formatted_address',
      'geometry.location',
      'place_id',
      'name',
      'address_components'
    ]
  }
};